<template>
	<div>
		<div class="head">
			<img src="../../assets/headImg/headimg.jpg" style="width: 100%;vertical-align: top;" />
		</div>
		<div class="head">
			<div class="retrun" @click="retrun2">
				返回首页
			</div>

			<!-- 切换栏 -->
			<div class="qiehuan">
				<div class="time" v-for="(item,index) in buttonList" :key=index @click="time(item.id,(index+1))" :class="myindex == (index+1)? 'blue':''">{{item.name}}</div>
			</div>

			<div class="flex" style="flex-wrap:wrap;">
				<div v-for="(tiem,index) in videoList" @click="goLive(tiem)" style="margin-top: 20px;cursor: pointer;" class="img-box"
				 :class="index == 5? 'isshow':''">
					<img :src="tiem.url" style="width: 100%;">
					<span class="title_img">{{tiem.liveName}}</span>
				</div>
			</div>
		</div>

		<logocom style="width: 100%;position: absolute;margin-left:50% ;transform: translateX(-50%);bottom: 10px;" class="logocom"></logocom>
	</div>
</template>

<script>
	import logocom from '@/components/logo/logo.vue';
	export default {
		components: {
			logocom
		},
		data() {
			return {
				myindex: 1,
				headimgList: [{
					url: require("@/assets/headImg/headimg.jpg"),
					id: 1
				}],
				buttonList: [{
						title: '11月27日上午'
					},
					{
						title: '11月27日下午'
					},
					{
						title: '11月28日'
					}
				],
				videoList: [{
					url: require('@/assets/video/1.png'),
					id: 1,
					title: '会场一'
				}]
			}
		},
		methods: {
			getTimeTagListFun() {
				let cnt = {
						status: 1, // Byte <选填> 状态：1
					};
				this.$api.getTimeTagList(cnt, res => {
					console.log(res, 5);
					this.buttonList = JSON.parse(res.data.c)
				})
			},

			retrun2: function() {
				this.$router.push({
					path: '/'
				})
			},
			goLive(info) {
				if (info.type == '小鹅通') {
					window.location.href = info.otherurl
				} else {
					this.$router.push({
						path: '/phoneLive',
						query: {
							id: info.id
						}
					})
				}
			},
			time(timestring, index) {
				this.myindex = index
				this.$api.getLiveList({
					status: 1,
					timestring: timestring
				}, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						this.videoList = JSON.parse(res.data.c)
					} else {
						this.$message.error(res.data.rm);
					}
				})
			}
		},
		mounted() {
			this.time(this.buttonList[0].title, 1);
			this.getTimeTagListFun();
		}
	}
</script>

<style lang="scss" scoped>
	@import "@/assets/style/style.scss";

	.retrun {
		margin: 20px 0;
		cursor: pointer;
		color: #4fb3ff;
	}

	.retrun:hover {
		color: #49a8eb;
	}

	.qiehuan {
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #f0f0f0;
		display: flex;
		align-items: center;
	}

	.time {
		font-size: 16px;
		margin-left: 25px;
		cursor: pointer;
	}

	.blue {
		background-color: #3d65e8;
		color: #fff;
		height: 35px;
		line-height: 35px;
		padding: 0 5px;
		border-radius: 5px;
	}

	.lunbo {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}

	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}

	.isshow {
		visibility: hidden;
	}

	.img-box {
		position: relative;
		width: 290px;
	}

	.title_img {
		position: absolute;
		z-index: 999;
		left: 5px;
		color: #fff;
		bottom: 5px;
		font-size: 20px;
	}

	.flex {
		width: 98%;
		margin: 0 auto;
	}

	.logocom {
		visibility: hidden;
	}

	@media (max-width: 500px) {
		.head {
			width: 100%;
			padding: 0;
		}

		.lunbo {
			width: 100%;
			padding-right: 0;
		}

		.retrun {
			display: none;
		}

		.img-box {
			width: 105px;
			margin: 0 auto;
			// flex-shrink: 0;
			// width: 50px;
			// height: 20px !important;
		}

		.title_img {
			font-size: 14px;
		}

		.flex {
			width: 95%;
			margin: 0 auto;
		}

		.logocom {
			visibility: visible;
		}

		.time {
			margin: 0 auto;
		}
	}
</style>
